import { Button, ButtonProps, ComponentWithAs, forwardRef } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import React from 'react';
import HomeIcon from '../atom/HomeIcon';

const HomeButton: ComponentWithAs<'button', ButtonProps> = forwardRef<ButtonProps, 'button'>((props, ref) => {
  return (
    <Button
      as={RouterLink}
      ref={ref}
      {...(props as ButtonProps)}
      to='/'
      borderRadius={'0 0 100% 0'}
      width={'4rem'}
      height={'4rem'}
      p={0}
      aria-label='메인으로'
    >
      <HomeIcon ml={-3} mt={-1} width={'1.35rem'} height={'1.275rem'} />
    </Button>
  );
});

export default HomeButton;
